import { createFileRoute, Outlet } from '@tanstack/react-router';

const OperatorsUsersLayoutPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute('/_protected/operators/users')({
  component: OperatorsUsersLayoutPage,
});
